import fineReimbursement from "./fineReimbursement.component";
import fineReimbursementUrls from "./fineReimbursement.urls";
import FineReimbursementTransforms from "./fineReimbursement.transforms";

const fineReimbursementModule = angular
  .module("app.components.fineReimbursement", [])
  .component("fineReimbursementPage", fineReimbursement)
  .service("FineReimbursementTransforms", FineReimbursementTransforms)
  .config(fineReimbursementUrls);

export default fineReimbursementModule;



// WEBPACK FOOTER //
// ./src/pages/fineReimbursement/fineReimbursement.module.js